/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
window.addEventListener("load", () => {
  ids = [];
  document.querySelectorAll("tab-triggers button").forEach((el) => {
    if (el.textContent == "Ski" || el.textContent == "Snowboard") {
      ids.push(el.id);
    }
  });
  document
    .querySelectorAll(".js-featured-collections-section tab-panel")
    .forEach((tabPanel) => {
      if (ids.includes(tabPanel.getAttribute("aria-labelledby"))) {
        let block = document.createElement("div");
        block.classList.add("ski-banner");
        block.textContent =
          "Take advantage of our exclusive summer offer for a discounted price on any purchase combination of ski or snow-related items.";
        tabPanel.prepend(block);
      }
      let direction = 1;
      let backButton = tabPanel.querySelector(".navigation__button--prev");
      let nextButton = tabPanel.querySelector(".navigation__button--next");
      let inittstamp = Number(new Date().getTime()) - 10000;
      if (backButton && nextButton) {
        nextButton.parentElement.setAttribute("data-timestamp", inittstamp);
        let buttons = [backButton, nextButton];
        let timer = setInterval(() => {
          let tstamp = Number(new Date().getTime());
          let oldtstamp = Number(
            buttons[0].parentElement.getAttribute("data-timestamp")
          );
          if (tstamp - oldtstamp >= 10000) {
            if (buttons[direction].getAttribute("disabled") == "") {
              direction = Number(!direction);
            }
            buttons[direction].click();

            setTimeout(()=>{
              buttons[0].parentElement.setAttribute("data-timestamp", oldtstamp);
            },500)
          }
        }, 3000);
        backButton.addEventListener("click", (el) => {
          let tstamp = new Date().getTime();
          // console.log(backButton.parentElement);
          backButton.parentElement.setAttribute("data-timestamp", tstamp);
        });
        nextButton.addEventListener("click", (el) => {
          let tstamp = new Date().getTime();
          // console.log(nextButton.parentElement);
          nextButton.parentElement.setAttribute("data-timestamp", tstamp);
        });
      }
    });
});
